// extracted by mini-css-extract-plugin
export default {"container":"PesertaForm_container__ingZQ","card":"PesertaForm_card__yWt-r","title":"PesertaForm_title__GuHlN"};